import PropTypes from "prop-types";

import DerivedLevelsTool, {
  derivedLevelsPropTypes,
  derivedLevelsBaseDefaults,
  derivedLevelsHoverTextDefaults,
} from "./DerivedLevelsTool";
import EachAverageLine from "./wrapper/EachAverageLine";

// Config sobre DerivedLevelsTool (auditoria 2026-07-17, item 1d);
// a matemática da média vive no EachAverageLine (helper próprio — meio-gêmeo)
class AverageLine extends DerivedLevelsTool {}

AverageLine.collectionKey = "averageLines";
AverageLine.EachComponent = EachAverageLine;
AverageLine.evoId = "interactive-average-line";

AverageLine.propTypes = {
  ...derivedLevelsPropTypes,
  averageLines: PropTypes.array.isRequired,
};

AverageLine.defaultProps = {
  ...derivedLevelsBaseDefaults,
  averageLines: [],
  hoverText: {
    ...derivedLevelsHoverTextDefaults,
    text: "Clique e arraste para criar Linha Média",
  },
};

export default AverageLine;
